import React from 'react';
import { Facebook, Linkedin, Twitter } from 'react-feather';
import { Link } from 'react-router-dom';
import { H6, P } from '../../../AbstractElements';

const OtherWay = () => {
  return (
    <>
      <P attrPara={{ className: 'text-center mb-0 pt-5 ' }}>
        Don't have account?
        <Link className='ms-2' to={`${process.env.PUBLIC_URL}/register`}>
          Create Account
        </Link>
      </P>
    </>
  );
};

export default OtherWay;
